"use client";

import React from "react";
import Link from "next/link";
import { Users, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { ColleagueCard } from "./ColleagueCard";
import type { CompanyNameContactsProps } from "./types";

export const CompanyNameContacts: React.FC<CompanyNameContactsProps> = ({
  colleagues,
  totalColleagues,
  companyName,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <LoadingSpinner size="md" />
      </div>
    );
  }

  if (colleagues.length === 0) {
    return (
      <div className="flex items-center gap-3 text-muted-foreground py-4">
        <Users className="h-4 w-4" />
        <span>This is the only contact at {companyName}</span>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {colleagues.map((colleague) => (
        <ColleagueCard key={colleague.id} colleague={colleague} />
      ))}

      {totalColleagues > colleagues.length && (
        <div className="pt-3 border-t">
          <Link href="/contacts">
            <Button variant="outline" size="sm" className="w-full flex items-center gap-2">
              View all {totalColleagues} contacts at {companyName}
              <ExternalLink className="h-3 w-3" />
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};
